import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import Loader from '../components/Loader';
import { ErrorFlash } from '../components/Flash';
import { useRequestAsync, getHeaders } from '../api/client';
import LoginPage from '../components/LoginPage';
import { ProfileContext } from '../profile';

interface Props extends RouteComponentProps<any> {}

type Credentials = {
  email: string;
};

export default function ForgotPassword(props: Props) {
  const context: any = React.useContext(ProfileContext);
  const [email, setEmail] = React.useState<string>(null);
  const [state, submit] = useRequestAsync((data: Credentials) => ({
    url: '/users/reset',
    method: 'POST',
    body: JSON.stringify(data),
    headers: getHeaders(context),
  }));

  if (state.complete && !state.error) {
    return (
      <LoginPage {...props}>
        <div className="pa4 black-80 ml-auto mr-auto w-70-ns">
          <h3 className="f3 f2-ns lh-title ma0 mb2 green">
            We've send you an email.
          </h3>
          <small className="f6 black-60 db mb3 mb4-ns lh-copy">
            You should soon receive an email with a link to set your new
            password.
          </small>
        </div>
      </LoginPage>
    );
  }

  return (
    <LoginPage {...props}>
      <form
        className="pa4 black-80 ml-auto mr-auto w-70-ns"
        method="POST"
        onSubmit={(e) => {
          e.preventDefault();
          submit({ email });
        }}
      >
        <h3 className="f3 f2-ns lh-title ma0 mb2 black">Reset your password</h3>
        <small className="f6 black-60 db mb3 mb4-ns lh-copy">
          Enter your email address below and if you have an account already we
          will send you a secure link to securely set a new password.
        </small>
        {state.error && <ErrorFlash error={state.error} />}
        {state.loading ? (
          <Loader />
        ) : (
          <React.Fragment>
            <div className="mv3-ns measure-wide">
              <label htmlFor="name" className="f6 b db mb2 ttu black-50 fw6">
                Email
              </label>
              <input
                id="name"
                className="input-reset ba b--black-20 pa2 mb2 db w-100"
                type="email"
                required
                defaultValue={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <button
              className="mv3 mv4-ns db link gold f3 b bw0 bg-ui-white-1 tl pa0 dim pointer bg-animate"
              type="submit"
            >
              Continue →
            </button>
          </React.Fragment>
        )}
      </form>
    </LoginPage>
  );
}
